export default "__VITE_ASSET__kyGE5Ga5__"